import { parseOpeningHours } from './parse-opening-hours';
export const parseCentreBannerHours = function parseCentreBannerHours(tradingHours, centreTimeZone, centreFeatures) {
  const defaultDay = {
    hours: [],
    text: {
      description: '',
      isColored: false
    }
  };
  const allHours = parseOpeningHours(tradingHours, centreTimeZone, centreFeatures);
  const today = allHours.find(tradingHour => tradingHour.day === 'Today') || defaultDay;
  return {
    text: today.text,
    hours: today.hours.join(', ')
  };
};